module.exports = __webpack_public_path__ + "img/email.802b1f32.svg";